import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { CommonTranslationModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/appclient';
import { MaterialModule } from '@sdbn/appclient';
import { TmcYardCommonModule } from 'src/tmc-yard/common/common.module';
import { TransportSelectionComponent } from './component/transport-selection.component';
import { CommonLayoutModule } from '@sdbn/common';

@NgModule({
  declarations: [
    TransportSelectionComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,
    MaterialModule,
    MatInputModule,
    MatTooltipModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    CommonTranslationModule,
    TmcYardCommonModule,
    CommonLayoutModule
  ],
  exports: [
    TransportSelectionComponent
  ]
})
export class TransportSelectionModule { }
